import React, { FC } from 'react'

const TermsOfService: FC<{ headerHeight: string }> = ({ headerHeight }) => {
  React.useEffect(() => {
    document.title = 'Terms of Service'
  }, [])

  return (
    <iframe
      style={{ height: 'calc(100vh - ' + headerHeight + ')' }}
      src="/static/pdf/Arpeggi - Online Terms of Service (1.23).pdf"
    />
  )
}

export default TermsOfService
